module.exports = __webpack_public_path__ + "static/bookmarc.25af110e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/bookmarc.jpg
// module id = 459
// module chunks = 202660965941462